export enum GraphQLErrorPolicies {
  None = 'none',
  Ignore = 'ignore',
  All = 'all',
}
